import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AppSettingsService } from 'src/app/services/app-settings.service';
import { CategoryFilterComponent } from '../category-filter/category-filter.component';
import { SortByComponent } from '../sort-by/sort-by.component';

@Component({
  selector: 'app-sort-by-button',
  templateUrl: './sort-by-button.component.html',
  styleUrls: ['./sort-by-button.component.scss'],
})
export class SortByButtonComponent implements OnInit {
  @Output() onFilterChanged = new EventEmitter();
  @Output() onFilterValuesChanged = new EventEmitter();
  @Input() categoryId: number;
  filterValue: object;
  constructor(private modalCtrl: ModalController) {}

  ngOnInit() {}

  async openModal() {
    const modal = await this.modalCtrl.create({
      component: SortByComponent,
    });
    modal.present();
    var result = await modal.onDidDismiss();
    if (result) {
      this.onFilterChanged.emit(result.data);
    }
  }

  async openfilterModal() {
    const modal = await this.modalCtrl.create({
      component: CategoryFilterComponent,
      componentProps: {
        filterData: this.filterValue ? this.filterValue : null,
        categoryId: this.categoryId,
      },
    });
    modal.present();
    var result = await modal.onDidDismiss();
    if (result) {
      this.filterValue = result.data;
      this.onFilterValuesChanged.emit(result.data);
    }
  }
}
